class Accordion {
    root: HTMLElement
    header: HTMLElement
    content: HTMLElement

    constructor(root: HTMLElement) {
        this.root = root
        this.header = this.root.querySelector('[data-accordion-state]') as HTMLElement
        this.content = this.root.querySelector('[data-accordion-content]') as HTMLElement

        this.initialize()

        if (this.root.matches(':first-child')) {
            // Find container (parent) to open first accordion on page load
            const container = this.root.closest('[data-accordion-container]')
            if (container && !container.classList.contains('folded')) {
                this.open(false)
            }
        }
    }

    initialize() {
        this.header.addEventListener('click', () => {
            if (this.header.getAttribute('data-accordion-state') === 'active') {
                this.close()
            } else {
                this.open()
            }
        })
    }

    open(scrollIntoView = true) {
        this.header.dataset.accordionState = 'active'
        this.header.classList.add('active')
        this.content.classList.add('active')
        if (scrollIntoView) {
            this.root.scrollIntoView({ behavior: 'smooth' })
        }
    }

    close() {
        this.header.dataset.accordionState = ''
        this.header.classList.remove('active')
        this.content.classList.remove('active')
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const accordionHeader = document.querySelectorAll<HTMLElement>('[data-accordion-state]')
    accordionHeader.forEach((accordionHeader) => {
        new Accordion(accordionHeader.parentElement as HTMLElement)
    })
})
